import { TriangleUpIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";
import { Marker as MapboxMarker } from "react-map-gl";
import { Coordinate } from "~/generated/graphql.types";

export const HyperlapseCurrentLocationMarker = ({
  coordinate,
  heading,
}: {
  coordinate: Coordinate;
  heading: number;
}) => {
  return (
    <MapboxMarker
      draggable
      latitude={coordinate.lat}
      longitude={coordinate.lon}
      rotation={heading}
    >
      <Flex
        w={5}
        h={5}
        alignItems="center"
        justifyContent="center"
        rounded="full"
        borderWidth={4}
        bgColor="#FFFFFF"
        borderColor="#4880C8"
      >
        <TriangleUpIcon
          position="absolute"
          top={-2}
          color="#4880C8"
          fontSize={"md"}
        />
      </Flex>
    </MapboxMarker>
  );
};
